import { Fragment } from 'react';

import PropTypes from 'prop-types';
import { NON_BREAKING_SPACE } from 'utils/constants/common';

import useTrls from 'hooks/translation/useTrls';

import AccountLink from 'components/Admin/Invoices/InvoicesTable/Invoice/Account/AccountLink';
import EmployerLink from 'components/Admin/Invoices/InvoicesTable/Invoice/Account/EmployerLink';
import ManagerLink from 'components/Admin/Invoices/InvoicesTable/Invoice/Account/ManagerLink';

import 'components/Admin/Invoices/InvoicesTable/Invoice/Account/Account.less';

const Account = ({ accountId, account }) => {
    const trl = useTrls();

    return (
        <Fragment>
            <p>
                <span className="employer-id">{trl('admin.Invoices.InvoicesTable.Invoice.employer')}</span>
                {NON_BREAKING_SPACE}-{NON_BREAKING_SPACE}
                <EmployerLink {...account} />
            </p>
            <p>
                {trl('admin.Invoices.InvoicesTable.Invoice.account')}
                {NON_BREAKING_SPACE}-{NON_BREAKING_SPACE}
                <AccountLink accountId={accountId} />
            </p>
            <p>
                <ManagerLink managerEmail={account.clickmeManagerEmail} />
            </p>
        </Fragment>
    );
};

Account.propTypes = {
    accountId: PropTypes.number,
    account: PropTypes.shape({
        clickmeManagerEmail: PropTypes.string,
    }),
};

export default Account;
